import Dto from "../service/Dto";
import GF from "../../utils/GF";

class Privilege extends Dto {

  static ALLOW_VISIBLE = 1;
  static ALLOW_VIEW = 2;
  static ALLOW_CREATE = 4;
  static ALLOW_EDIT = 8;
  static ALLOW_DELETE = 16;
  static ALLOW_SORT = 32;
  static ALLOW_FILTER = 64;
  static ALLOW_IMPORT = 128;
  static ALLOW_EXPORT = 256;
  static ALLOW_CONNECT = 512;
  static ALLOW_DISCONNECT = 1024;

  constructor() {
    super('po2\\types\\Privilege');
  }

  static isPrivilegeAllowed(privilegeValue, privilege) {
    return GF.isBitSet(privilegeValue, privilege);
  }

  static checkPrivilegeIsAllowed(privileges, privilegeName, protection) {
    let retVal = false;
    let protectionFromPrivileges = Privilege.getProtectionFromPrivileges(privileges, privilegeName);
    if (Privilege.isPrivilegeAllowed(protectionFromPrivileges, protection)) {
      retVal = true;
    }
    return retVal;
  }

  static getProtectionFromPrivileges(privileges, privilegeName) {
    let protectionRetVal = 0;
    if (Array.isArray(privileges)) {
      for (let i = 0; i < privileges.length; i++) {
        let privilege = privileges[i];

        if (privilege.name === privilegeName) {
          protectionRetVal = privilege.protection;
          break;
        }
      }
    }
    return protectionRetVal;
  }
}

export default Privilege
